import React from 'react'
import classnames from 'classnames/bind'
import styles from './IconButton.module.css'

const cx = classnames.bind(styles)

export interface IconButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label: string
  hasNotification?: boolean
  children: React.ReactNode
}

const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  (
    { label, hasNotification = false, className, children, ...rest },
    ref
  ) => {
    return (
      <button
        ref={ref}
        type="button"
        className={cx('iconButton', className)}
        aria-label={label}
        {...rest}
      >
        {children}
        {hasNotification && (
          <span className={styles.notification} aria-hidden="true" />
        )}
      </button>
    )
  }
)

IconButton.displayName = 'IconButton'

export default IconButton
